import styles from '../../pages/home_page/Hero.module.scss';

export const Ellipse2 = () => {
    return (
        <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.ellipse2}>
            <circle cx="27" cy="27" r="27" fill="#7A79CE"/>
        </svg>   
    )
}